import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("TRANSLATION/LOAD_ALL");
export const change = createRoutine("TRANSLATION/CHANGE");
export const loadGroups = createRoutine("TRANSLATION/LOAD_GROUPS");
